module.exports = __webpack_public_path__ + "img/elevatorVideo.9e3a02ce.jpg";